import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const TreesPage: React.FC = () => {
 return (
    <div className={styles.container}>
      <h1 className={styles.title}>Trees</h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title='BinaryTrees'
          description='A hierarchical structure where each node has up to two children.'
          link ='/trees/binarytrees'
          icon='🌳'
          />
        <TopicCard
          title='BinarySearchTrees'
          description='A sorted tree where left nodes are smaller and right nodes are larger.'
          link ='/trees/binarysearchtrees'
          icon='🌲'
          />
        <TopicCard
          title='CompareTrees'
          description='Compare how Binary and BST structures manage and retrieve data.'
          link ='/trees/comparetrees'
          icon='⚖️'
          />
      </div>
    </div>
  );
};

export default TreesPage;